const o=10;export{o as DEFAULT_LIST_LOADING_LINES};
//# sourceMappingURL=GridDetailsList.constants.js.map
